/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {Cacheable} from '../../decorators/cacheable.decorator';
import {SettingConfigModel} from './contracts/setting-config.model';
import {AlertBaseContract} from './contracts/alert-base.contract';

@Injectable({
    providedIn: 'root'
})
export class SettingApi {

    private settingsBaseUrl = `${environment.settingsBaseUrl}/api/setting`;
    private alertBaseUrl = `${environment.settingsBaseUrl}/api/alert`;

    constructor(private http: HttpClient) {
    }

    /**
     * Retrieve the settings configuration
     * @return the settings configuration model SettingConfigModel
     */
    @Cacheable()
    getSettingConfig(): Observable<SettingConfigModel> {
        return this.http.get<SettingConfigModel>(`${this.settingsBaseUrl}/config`);
    }

    /**
     * Retrieve all the alerts active
     * @return the alerts active contract AlertBaseContract
     */
    getAllCurrentAlerts(): Observable<AlertBaseContract[]> {
        return this.http.get<AlertBaseContract[]>(`${this.alertBaseUrl}/base/current`);
    }
}
